import React from "react";
import PrimarySearchAppBar from "../../components/Navbar";
import {Box} from "@mui/material";
import {useSelector} from "react-redux";

const DefaultLayoutNoSideBar = ({ page, children,
    mainBoxSx = {
        display: "flex",
        height: "95.5vh",
        overflow: "hidden",
    },
    contentBoxSx = {
        backgroundColor: "#FAFAFA",
        flex: 1,
        paddingTop: 2,
        width: "calc(100vw - 180px)",
        height: "100%",
        overflow: "auto",
    }}) => {
  const { account_id = "" } = useSelector(
    (state) => state?.account?.account || {}
  );

  return (
    <>
      <PrimarySearchAppBar />

      <Box
        className="mainBox"
        sx={{
            ...mainBoxSx
        }}
      >
        <Box
          sx={{
              ...contentBoxSx
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
};
export default DefaultLayoutNoSideBar;
